/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offer_Free_DescInputs */

const en_offer_free_desc = /** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer this item, download, or service completely free`)
};

const id_offer_free_desc = /** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawarkan barang, unduhan, atau layanan ini secara gratis`)
};

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const es_offer_free_desc = en_offer_free_desc;

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const fr_offer_free_desc = en_offer_free_desc;

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const de_offer_free_desc = en_offer_free_desc;

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const ja_offer_free_desc = en_offer_free_desc;

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const zh_offer_free_desc = en_offer_free_desc;

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const ar_offer_free_desc = en_offer_free_desc;

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const it_offer_free_desc = en_offer_free_desc;

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const ru_offer_free_desc = en_offer_free_desc;

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const pt_offer_free_desc = en_offer_free_desc;

/** @type {(inputs: Offer_Free_DescInputs) => LocalizedString} */
const ko_offer_free_desc = en_offer_free_desc;

/**
* | output |
* | --- |
* | "Offer this item, download, or service completely free" |
*
* @param {Offer_Free_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const offer_free_desc = /** @type {((inputs?: Offer_Free_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offer_Free_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_offer_free_desc(inputs)
	if (locale === "es") return es_offer_free_desc(inputs)
	if (locale === "fr") return fr_offer_free_desc(inputs)
	if (locale === "de") return de_offer_free_desc(inputs)
	if (locale === "ja") return ja_offer_free_desc(inputs)
	if (locale === "zh") return zh_offer_free_desc(inputs)
	if (locale === "ar") return ar_offer_free_desc(inputs)
	if (locale === "id") return id_offer_free_desc(inputs)
	if (locale === "it") return it_offer_free_desc(inputs)
	if (locale === "ru") return ru_offer_free_desc(inputs)
	if (locale === "pt") return pt_offer_free_desc(inputs)
	return ko_offer_free_desc(inputs)
});